module.exports = __webpack_public_path__ + "static/scale-model-of-lafayette-louisiana-39289ad96dc51e935320a811b990db4e.png";